module.exports = __webpack_public_path__ + "img/msbsde_header.d80bccd9.png";